import { BehaviorSubject } from 'rxjs';

export const mainBannerOffset$ = new BehaviorSubject({});

export const mainBannerOffset = mainBannerOffset$.asObservable();